<script setup lang="ts">
import AuthLayout from "./layouts/AuthLayout.vue";
</script>
<template>
  <AuthLayout>
    <v-sheet width="450" class="mx-auto pa-12 text-center" rounded="lg" elevation="8">
      <v-icon icon="mdi-emoticon-dead-outline" size="96" color="error" class="mb-4"/>
      <h1 class="text-h2 font-weight-bold mb-2">404</h1>
      <p class="text-subtitle-1 mb-6">The page you're looking for doesn't exist... or maybe it never did.</p>
      <v-btn variant="flat" color="primary" to="/">Return Home</v-btn>
    </v-sheet>
  </AuthLayout>
</template>